module.exports = __webpack_public_path__ + "static/media/logo_xiaomi.369877e0.png";